import React, { useEffect, useState } from "react";
import TabsSection from "../../Components/Tabs/TabsSection";
import VouchersDashboard from "./VouchersDashboard";
import ManageVouchers from "./ManageVouchers";
import SideBar from "../SideBar/SideBar";
import Loader from "../../Components/Loader/Loader";
import Transactions from "./Transactions";
import BackButton from "../BackButton/BackButton";
import { FeaturedVouchers } from "./FeaturedVouchers";
import PrivacyTermsConditions from "./../PrivacyTermsConditions/PrivacyTermsConditions";

const Vouchers = () => {
  const [title, setTitle] = useState("");
  const [currentTab, setcurrentTab] = useState("");
  const [loading, setLoading] = useState(false);

  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    const url = endPath[4].replace(/-/g, " ");
    const arr = url.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const url_final = arr.join(" ");
    setTitle(url_final);
    if (endPath[4] === "vouchers-dashboard") {
      setcurrentTab("vouchers-dashboard");
    }
    if (endPath[4] === "manage-vouchers") {
      setcurrentTab("manage-vouchers");
    }
    if (endPath[4] === "transactions") {
      setcurrentTab("transactions");
    }
    if (endPath[4] === "featured-vouchers") {
      setcurrentTab("featured-vouchers");
    }
  }, [path]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4 VoucherDash">
          <BackButton />
          <p className="page-maintitle">Vouchers</p>
          <div className="acc-dashboard mt-4">
            <TabsSection />

            {currentTab == "vouchers-dashboard" && (
              <VouchersDashboard loading={loading} setLoading={setLoading} />
            )}

            {currentTab == "manage-vouchers" && (
              <ManageVouchers loading={loading} setLoading={setLoading} />
            )}
            {currentTab == "transactions" && (
              <Transactions loading={loading} setLoading={setLoading} />
            )}
            {currentTab == "featured-vouchers" && (
              <FeaturedVouchers loading={loading} setLoading={setLoading} />
            )}
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default Vouchers;
